// extracted by mini-css-extract-plugin
export var tosLink = "_40-0";